import React, { useEffect, useState } from "react";
import DashboardLayout from "../DashboardLayout";
import apiClient from "../../utils/apiClient";
import ShowStraddleHistoryData from "./showStraddleHistoryData";

export default function StraddleDashboard() {
  const [straddleData, setStraddleData] = useState([]);
  const [filteredFyersStraddleHistoryData, setFilteredFyersStraddleHistoryData] =
    useState(straddleData);
  const [sortOrder, setSortOrder] = useState("asc");

  const getAccountName = () => {
    let config = {
      method: "get",
      url: "api/stradddle-chain",
      headers: {
        "Content-Type": "application/json",
      },
    };

    apiClient
      .request(config)
      .then((response) => {
        setStraddleData(response.data);
        setFilteredFyersStraddleHistoryData(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  useEffect(() => {
    getAccountName();
  }, []);

  // straddleData.sort((a, b) =>
  //   a.underlying_scrip_code.localeCompare(b.underlying_scrip_code)
  // );

  const handleResetFilterData = () => {
    setFilteredFyersStraddleHistoryData(straddleData);
  };

  return (
    <DashboardLayout>
      <div className="flex flex-col relative  w-full max-h-screen">
        <div className="flex flex-col flex-1 ">
          <ShowStraddleHistoryData 
          straddleData={straddleData}
          setStraddleData={setStraddleData}
          filteredFyersStraddleHistoryData={filteredFyersStraddleHistoryData}
          setFilteredFyersStraddleHistoryData={setFilteredFyersStraddleHistoryData} 
          sortOrder={sortOrder}
          setSortOrder={setSortOrder} 
          handleResetFilterData={handleResetFilterData}
          />
        </div>
      </div>
    </DashboardLayout>
  );
}
